import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
// import ArrowUpward from "@material-ui/icons/ArrowUpward";
// import AccessTime from "@material-ui/icons/AccessTime";
import Delete from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";

// core components
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import defaultImage from "assets/img/image_placeholder.jpg";

/* eslint-disable */
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";

class CardsWithAnimation extends React.Component {
  constructor(props) {
      super(props);
      this.handleEdit = this.handleEdit.bind(this);
      this.handleDelete = this.handleDelete.bind(this);
  }
  
  handleEdit() {
    this.props.handleEdit(this.props.id, this.props.data)
  }
  handleDelete() {
    this.props.handleDelete(this.props.id, this.props.data);
  }
  render() {
    const { classes, data, id, imgWidth, imgHeight, cardWidth } = this.props;
    return (
      <div>
            <Card product className={classes.cardHover} style={{width: cardWidth}}>
                <CardHeader image className={classes.cardHeaderHover}>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img src={(data) ? data.image_url : defaultImage} style={{width: imgWidth, height: imgHeight}} alt="..." />
                    </a>
                </CardHeader>
              <CardBody>
                <div className={classes.cardHoverUnder}>
                  <Tooltip
                    id="tooltip-top"
                    title="Delete"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button simple color="transparent" justIcon onClick={this.handleDelete}>
                      <Delete className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    id="tooltip-top"
                    title="Change Details"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button color="transparent" simple justIcon onClick={this.handleEdit}>
                      <Edit className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                </div>
                <h4 className={classes.cardTitle}>{(data) ? data.type : ""}</h4>
                {/* <p className={classes.cardCategory}>
                  <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} />
                  </span>
                  
                </p> */}
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                {(data) ? data.description : ""}.
                </div>
              </CardFooter>
            </Card>
         
      </div>
    );
  }
}

CardsWithAnimation.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(CardsWithAnimation);



// WEBPACK FOOTER //
// ./src/views/Cards/CardsWithAnimation.jsx